export default __webpack_public_path__ + "static/media/MiturLogoSecondary.58a7cce1.png";